const LogoSmall: React.FC = () => (
	<img style={{ width: '32.599px', height: '36px', flexShrink: 0 }} src="/logo-small.png" alt="Evidia logo" />
);

export default LogoSmall;
